import {
  Button,
  Card,
  Checkbox,
  Classes,
  Dialog,
  Elevation,
  FormGroup,
  InputGroup,
  Menu,
  MenuItem,
  OverlayToaster,
  Popover,
  Position,
  Spinner,
  TextArea,
  Callout
} from '@blueprintjs/core';
import {Select} from '@blueprintjs/select';
import {saveAs} from 'file-saver';
import i18next from 'i18next';
import React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import i18n from '../../../i18n';
import {
  authenticatedDeleteFetch,
  authenticatedGetFetch,
  authenticatedPatchFetch,
  authenticatedPostFetchWithResult,
} from '../../../utils/AuthenticatedFetch';
import { EquipmentSelect } from '../../Structure/EquipmentSelector';
import { GranularitySelect } from '../../Structure/GranularitySelector';
import { MultiParkSelect, ParkSelect } from '../../Structure/ParkSelector';
import Title from '../../Structure/logo';

const labels = [
  {index: 'fr', label: 'start date'},
  {index: 'to', label: 'end date'},
  {index: 'handleZero', label: 'handle zero'},
  {index: 'lg', label: 'language'},
  {index: 'parks', label: 'parks'},
  {index: 'parlist', label: 'parks'},
  {index: 'park', label: 'park'},
  {index: 'equipment', label: 'equipment'},
  {index: 'equipments', label: 'equipments'},
  {index: 'g', label: 'granularity'},
  {index: 'api_url', label: 'api url'},
];

class CustomReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSettings: false,
      filterCategory: undefined,
      api_key: '',
      loading_key: false,
      loading_export_all: false,
      loading_download: false,
      categories: [],
      fromDate: new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().split('T')[0],
      toDate: new Date().toISOString().split('T')[0],
      handleZero: false,
      lg: 'fr',
      iFrame: undefined,
      id: undefined,
      allReports: [],
      showImportPopup: false,
      importName: '',
      lastImport: '',
      importDescription: '',
      category: '',
      importFile: undefined,
      adapter: undefined,
      subreport: undefined,
      g: 0,
      reportParams: [],
      parks: [],
      device: undefined,
      reportError: false,

      // Edit Report
      showEdit: false,
      editName: '',
      editDescription: '',
      editCategory: undefined,

      // Add Category
      showAddCategory: false,
    };
  }

  updateiFrame() {
    this.setState({iFrame: undefined, reportError: false});
    if (!this.state.id) return;
    authenticatedPostFetchWithResult(
      '/customReport/runReport',
      {
        id: this.state.id,
        format: 'html',
        params: {
          fr: this.state.fromDate,
          to: this.state.toDate,
          handleZero: this.state.handleZero,
          lg: this.state.lg,
          parks: this.state.parks || undefined,
          parklist: this.state.parks || undefined,
          park: this.state.parks.length === 1 ? this.state.parks[0].id : undefined,
          equipment: this.state.device ? this.state.device : 0,
          g: this.state.g,
        },
      },
      (_status, data) => {
        this.setState({iFrame: data, reportError: false, lastImport: ''});
      },
      (_error) => {
        this.setState({iFrame: undefined, reportError: true});
        if (this.state.allReports.length > 0)
          this.showToaster(`${i18n.t('something went wrong')}`, 'danger', 'warning-sign');
      },
      true
    );
  }

  getAllCategories() {
    authenticatedGetFetch('/customReport/getCategories', (response) => {
      this.setState({
        categories: response,
      });
    });
  }

  showLoadingSpinner() {
    return <Spinner intent="primary" size={Spinner.SIZE_STANDARD} />;
  }

  toasterRef = React.createRef();

  showToaster(msg, intent, icon) {
    this.toasterRef.current?.show({
      message: msg,
      intent: intent,
      icon: icon,
      timeout: 2500,
    });
  }

  getReportParams() {
    authenticatedGetFetch(`/customReport/getReportParams/${this.state.id}`, (response) => {
      this.setState({
        reportParams: response,
      });
    });
  }

  downloadFile(format) {
    this.setState({loading_download: true});
    let mimeType = '';
    switch (format) {
      case 'pdf':
        mimeType = 'application/pdf';
        break;
      case 'html':
        mimeType = 'text/html';
        break;
      case 'csv':
        mimeType = 'text/csv';
        break;
      case 'xlsx':
        mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        break;
      case 'docx':
        mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        break;
      default:
        mimeType = 'application/pdf';
        break;
    }

    authenticatedPostFetchWithResult(
      '/customReport/runReport',
      {
        id: this.state.id,
        format: format,
        params: {
          fr: this.state.fromDate,
          to: this.state.toDate,
          handleZero: this.state.handleZero,
          lg: this.state.lg,
          parks: this.state.parks || undefined,
          parklist: this.state.parks || undefined,
          park: this.state.parks.length === 1 ? this.state.parks[0].id : undefined,
          equipment: this.state.device ? this.state.device : 0,
          g: this.state.g,
        },
      },
      (_res, data) => {
        saveAs(
          new Blob([data], {type: `${mimeType};charset=utf-8`}),
          `report_${new Date().toJSON().slice(0, 10)}.${format}`
        );
        this.setState({loading_download: false});
      },
      (_error) => {
        this.setState({loading_download: false});
      },
      true
    );
  }

  getAllReports() {
    authenticatedGetFetch('/customReport/getAllReports', (response) => {
      if (response.length > 0) {
        const allReports = this.state.filterCategory
          ? response.filter((report) => report.category.id === this.state.filterCategory.id)
          : response;
          if (allReports.length === 0) {
            this.setState({
              allReports: [],
              id: undefined,
              reportParams: [],
            });
            this.showToaster(`${i18n.t('categorie empty')}`, 'warning', 'warning-sign');
            return;
          }
        this.setState({
          allReports: allReports,
          id: this.state.lastImport ? allReports.find((report) => report.name === this.state.lastImport).id : allReports[0].id,
        });
        this.updateiFrame();
        this.getReportParams();
      } else {
        this.setState({
          allReports: [],
          id: undefined,
          reportParams: [],
        });
        this.updateiFrame();
      }
    });
  }

  handleChangeFile(file) {
    const fileData = new FileReader();
    fileData.readAsText(file);
    fileData.onload = (e) => {
      this.setState({importFile: e.target.result});
    };
  }

  handleMultipleFile(target) {
    const files = target.files;
    const array = [];
    for (let i = 0; i < files.length; i++) {
      const fileData = new FileReader();
      fileData.readAsDataURL(files[i]);
      fileData.onload = (e) => {
        array.push({content: e.target.result.substring(e.target.result.indexOf(',') + 1), name: files[i].name});
      };
    }
    return array;
  }

  handleImport() {
    authenticatedPostFetchWithResult(
      '/customReport/saveReport',
      {
        name: this.state.importName,
        description: this.state.importDescription,
        category: this.state.category.id,
        file: this.state.importFile,
        subreport: this.state.subreport,
        adapter: this.state.adapter,
      },
      (res, _data) => {
        if (res === 201) {
          this.getAllReports();
          this.showToaster(`${i18n.t('report')} ${this.state.importName} ${i18n.t('imported')}`, 'success', 'tick');
          this.setState({showImportPopup: false, lastImport: this.state.importName});
        }
      },
      (_error) => {
        this.showToaster(`${i18n.t('error importing report')}`, 'danger', 'warning-sign');
      },
      true
    );
  }

  async getApiKey() {
    authenticatedGetFetch('/customReport/apiKey', (response) => {
      this.setState({
        api_key: response.key,
      });
    });
  }

  async componentDidMount() {
    this.getAllCategories();
    this.getAllReports();
    this.getApiKey();
  }

  render() {
    return (
      <div>
        <div className="component-body">
          <Title text={<Trans>custom report</Trans>}></Title>
          <div style={{display: 'flex', flexDirection: 'row'}}>
            { this.state.categories.length > 0 && (
              <Button
                intent="primary"
                icon="import"
                style={{marginBottom: '10px'}}
                onClick={() => this.setState({showImportPopup: !this.state.showImportPopup})}
              >
                {i18next.t('import')}
              </Button> )}

              <Button icon="cog" style={{marginBottom: '10px', marginLeft: '5px'}} onClick={() => this.setState({showSettings: true})}>
                {i18next.t('settings')}
              </Button>
          </div>



        {/*Settings dialog for the API KEY*/}
        <Dialog
            isOpen={this.state.showSettings}
            onClose={() => this.setState({showSettings: false})}
            title={i18next.t('settings')}
            canEscapeKeyClose={true}
            canOutsideClickClose={true}
            id="settingsDialog"
          >
            <div className={Classes.DIALOG_BODY}>
              <FormGroup label={i18next.t('api key')} labelFor="api_key" 
                helperText={i18next.t('set the api key to use the custom report')}
              >
                <InputGroup
                  id="api_key"
                  name="api_key"
                  leftIcon="key"
                  type='text'
                  maxLength={100}
                  value={this.state.api_key}
                  onChange={(e) => this.setState({api_key: e.target.value})}
                />
              </FormGroup>

              <div className="flexbox-center">
                <FormGroup>
                  <Button
                    id="confirm"
                    name="confirm"
                    disabled={!this.state.api_key || this.state.api_key.length < 20}
                    text={i18next.t('confirm')}
                    intent="primary"
                    type="submit"
                    icon="small-tick"
                    loading={this.state.showSettings && this.state.loading_key}
                    onClick={() => {
                      this.setState({loading_key: true});
                      if (!this.state.api_key) return;
                      authenticatedPatchFetch(
                        '/customReport/updateApiKey',
                        {
                          apiKey: this.state.api_key,
                        },
                        (res) => {
                          if (res === 200) {
                            this.showToaster(`${i18n.t('settings updated')}`, 'success', 'tick');
                            this.getAllReports();
                            this.setState({showSettings: false, loading_key: false});
                          }
                        },
                        () => {
                          this.showToaster(`${i18n.t('error updating settings')}`, 'danger', 'warning-sign');
                          this.setState({loading_key: false});
                        }
                      );
                    }}
                  />
                  <Button
                    id="cancel"
                    name="cancel"
                    text={i18next.t('cancel')}
                    intent="warning"
                    icon="undo"
                    style={{marginLeft: '5px'}}
                    onClick={() => this.setState({showSettings: false})}
                  />
                </FormGroup>
              </div>
            </div>
          </Dialog>

          <OverlayToaster
            className={Classes.TOAST_CONTAINER}
            usePortal={true}
            ref={this.toasterRef}
            position={Position.TOP}
          />

          {/*START IMPORT REPORT*/}
          <Dialog
            isOpen={this.state.showImportPopup}
            onClose={() => this.setState({showImportPopup: false})}
            title={i18next.t('import report')}
            canEscapeKeyClose={true}
            canOutsideClickClose={true}
            id="importDialog"
          >
            <div className={Classes.DIALOG_BODY}>
              <FormGroup label={<Trans>name</Trans>} labelFor="importName">
                <InputGroup
                  id="importName"
                  maxLength={50}
                  type="text"
                  name="importName"
                  value={this.state.importName}
                  onChange={(e) => this.setState({importName: e.target.value.split(' ').join('_')})}
                />
              </FormGroup>

              <FormGroup label={<Trans>description</Trans>} labelFor="importDescription">
                <TextArea
                  style={{width: '100%'}}
                  autoResize={true}
                  maxLength={200}
                  type="text"
                  id="importDescription"
                  name="importDescription"
                  value={this.state.importDescription}
                  onChange={(e) => this.setState({importDescription: e.target.value})}
                />
              </FormGroup>

              <FormGroup label={<Trans>category</Trans>} labelFor="importCategory">
                <Select
                  id="importCategory"
                  name="importCategory"
                  items={this.state.categories}
                  selectedItems={this.state.category ? [this.state.category] : []}
                  itemRenderer={(item, {handleClick}) => {
                    return (
                      <MenuItem
                        active={this.state.category && item.id === this.state.category.id}
                        key={item.id}
                        onClick={handleClick}
                        text={item.name}
                      />
                    );
                  }}
                  tagRenderer={(item) => item}
                  filterable={true}
                  onItemSelect={(item) => {
                    this.setState({category: item});
                  }}
                >
                  <Button
                    text={this.state.category ? this.state.category?.name : i18next.t('select category')}
                    rightIcon="double-caret-vertical"
                  />
                </Select>
              </FormGroup>

              <FormGroup label={<Trans>upload report file</Trans>} labelFor="importFile">
                <input
                  id="importFile"
                  name="importFile"
                  type="file"
                  accept=".jrxml"
                  onChange={(e) => this.handleChangeFile(e.target.files[0])}
                />
              </FormGroup>

              <FormGroup label={<Trans>upload adapter file</Trans>} labelFor="adapters">
                <input
                  id="adapters"
                  name="adapters"
                  type="file"
                  accept=".xml"
                  multiple
                  onChange={(e) => this.setState({adapter: this.handleMultipleFile(e.target)})}
                />
              </FormGroup>

              <FormGroup label={<Trans>upload subreport file</Trans>} labelFor="subreports">
                <input
                  id="subreports"
                  name="subreports"
                  type="file"
                  accept=".jrxml"
                  multiple
                  onChange={(e) => this.setState({subreport: this.handleMultipleFile(e.target)})}
                />
              </FormGroup>

              <div className="flexbox-center">
                <FormGroup>
                  <Button
                    id="import"
                    name="import"
                    text={i18next.t('import')}
                    intent="primary"
                    type="submit"
                    icon="document"
                    disabled={
                      !this.state.importName ||
                      !this.state.importDescription ||
                      !this.state.category ||
                      !this.state.importFile
                    }
                    onClick={() => {
                      this.handleImport();
                    }}
                  />
                  <Button
                    id="cancel"
                    name="cancel"
                    text={i18next.t('cancel')}
                    intent="warning"
                    icon="undo"
                    style={{marginLeft: '5px'}}
                    onClick={() => this.setState({showImportPopup: false})}
                  />
                </FormGroup>
              </div>
            </div>
          </Dialog>

          {/*END IMPORT REPORT*/}

          {/*START ADD CATEGORY*/}
          <div style={{maxWidth: '50%'}}>
            <div style={{display: 'flex', flexDirection: 'row'}}>
              <Select
                id="filterCategory"
                items={this.state.categories}
                selectedItems={this.state.filterCategory}
                popoverProps={{minimal: true}}
                itemRenderer={(item, {handleClick}) => {
                  return (
                    <MenuItem
                      active={this.state.filterCategory && item.id === this.state.filterCategory.id}
                      key={item.id}
                      onClick={handleClick}
                      text={item.name}
                    />
                  );
                }}
                filterable={true}
                itemsPredicate={(query, items) => {
                  return items.filter((item) => item.name.toLowerCase().includes(query.toLowerCase()));
                }}
                onItemSelect={(item) => {
                  this.setState({filterCategory: item});
                  this.getAllReports();
                }}
              >
                <Button
                  text={this.state.filterCategory ? this.state.filterCategory.name : i18next.t('filter by category')}
                  rightIcon="double-caret-vertical"
                />
                {this.state.filterCategory && (
                  <Button
                    rightIcon="cross"
                    onClick={() => {
                      this.getAllCategories();
                      this.getAllReports();
                      this.setState({filterCategory: undefined});
                    }}
                  />
                )}
              </Select>

              <Button
                icon="add"
                style={{marginLeft: '5px'}}
                onClick={() => {
                  this.setState({showAddCategory: true, category: ''});
                }}
              >
                <Trans>add category</Trans>
              </Button>

            { this.state.allReports.length > 0 && (
              <Button
                icon="export"
                style={{marginLeft: '5px'}}
                loading={this.state.loading_export_all}
                onClick={() => {
                  this.showToaster(`${i18n.t('exporting all reports, please wait')}`, 'primary', 'cloud-download');
                  this.setState({loading_export_all: true});
                  authenticatedPostFetchWithResult(
                    '/customReport/exportReport',
                    {
                      all: true
                    },
                    (_res, data) => {
                      saveAs(
                        new Blob([data], {type: 'application/zip;charset=utf-8'}),
                        `report_all.zip`
                      );
                      this.setState({loading_export_all: false});
                    },
                    () => {
                      this.showToaster(`${i18n.t('error exporting')}`, 'danger', 'warning-sign');
                      this.setState({loading_export_all: false});
                    },
                    true
                  );
                }
              }>
                {i18next.t('export all reports')}
              </Button>
            )}
            </div>
          </div>

          <Dialog
            isOpen={this.state.showAddCategory}
            onClose={() => this.setState({showAddCategory: false})}
            title={<Trans>add category</Trans>}
            canEscapeKeyClose={true}
            canOutsideClickClose={true}
            id="editDialog"
          >
            <div className={Classes.DIALOG_BODY}>
              <FormGroup label={i18next.t('name')} labelFor="f">
                <InputGroup
                  id="name"
                  maxLength={30}
                  type="text"
                  name="name"
                  value={this.state.category}
                  onChange={(e) => this.setState({category: e.target.value.split(' ').join('_')})}
                />
              </FormGroup>

              <div className="flexbox-center">
                <FormGroup>
                  <Button
                    id="confirm"
                    name="confirm"
                    text={i18next.t('confirm')}
                    intent="primary"
                    type="submit"
                    icon="small-tick"
                    disabled={!this.state.category}
                    onClick={() => {
                      this.setState({showEdit: false});
                      authenticatedPostFetchWithResult(
                        '/customReport/addCategory',
                        {
                          name: this.state.category,
                        },
                        (res, data) => {
                          this.setState({showAddCategory: false});
                          if (res === 201) {
                            this.getAllCategories();
                            this.showToaster(
                              `${i18n.t('category')} ${this.state.category} ${i18n.t('added')}`,
                              'success',
                              'tick'
                            );
                          }
                        },
                        () => {
                          this.showToaster(
                            `${i18n.t('error adding')} ${this.state.category}`,
                            'danger',
                            'warning-sign'
                          );
                        }
                      );
                    }}
                  />
                  <Button
                    id="cancel"
                    name="cancel"
                    text={i18next.t('cancel')}
                    intent="warning"
                    icon="undo"
                    style={{marginLeft: '5px'}}
                    onClick={() => this.setState({showEdit: false})}
                  />
                </FormGroup>
              </div>
            </div>
          </Dialog>

          {/*END ADD CATEGORY*/}

          <Dialog
            isOpen={this.state.showEdit}
            onClose={() => this.setState({showEdit: false})}
            title={`${i18next.t('edit')} ${this.state.editName}`}
            canEscapeKeyClose={true}
            canOutsideClickClose={true}
            id="editDialog"
          >
            <div className={Classes.DIALOG_BODY}>
              <FormGroup label={i18next.t('name')} labelFor="name">
                <InputGroup
                  maxLength={50}
                  id="name"
                  type="text"
                  name="name"
                  disabled={true}
                  value={this.state.editName}
                  onChange={(e) => this.setState({editName: e.target.value.split(' ').join('_')})}
                />
              </FormGroup>

              <FormGroup label={i18next.t('description')} labelFor="description">
                <TextArea
                  style={{width: '100%'}}
                  autoResize={true}
                  id="description"
                  maxLength={200}
                  type="textArea"
                  name="description"
                  value={this.state.editDescription}
                  onChange={(e) => this.setState({editDescription: e.target.value})}
                />
              </FormGroup>

              <FormGroup label={i18next.t('category')} labelFor="editCategory">
                <Select
                  id="editCategory"
                  name="editCategory"
                  items={this.state.categories}
                  selectedItems={this.state.editCategory}
                  itemRenderer={(item, {handleClick}) => {
                    return (
                      <MenuItem
                        active={this.state.editCategory && item.id === this.state.editCategory.id}
                        key={item.id}
                        onClick={handleClick}
                        text={item.name}
                      />
                    );
                  }}
                  tagRenderer={(item) => item}
                  filterable={true}
                  onItemSelect={(item) => {
                    this.setState({editCategory: item});
                  }}
                >
                  <Button
                    text={this.state.editCategory ? this.state.editCategory.name : i18next.t('select category')}
                    rightIcon="double-caret-vertical"
                  />
                </Select>
              </FormGroup>

              <div className="flexbox-center">
                <FormGroup>
                  <Button
                    id="confirm"
                    name="confirm"
                    text={i18next.t('confirm')}
                    intent="primary"
                    type="submit"
                    icon="small-tick"
                    disabled={!this.state.editName || !this.state.editDescription || !this.state.editCategory}
                    onClick={() => {
                      authenticatedPatchFetch(
                        `/customReport/editReport/${this.state.id}`,
                        {
                          description: this.state.editDescription,
                          category: this.state.editCategory.id,
                        },
                        (res) => {
                          if (res === 200) {
                            this.getAllReports();
                            this.showToaster(
                              `${i18n.t('report')} ${this.state.editName} ${i18n.t('edited successfully"')}`,
                              'success',
                              'tick'
                            );
                          }
                          this.setState({showEdit: false});
                        },
                        () => {
                          this.showToaster(
                            `${i18n.t('error editing')} ${this.state.editName}`,
                            'danger',
                            'warning-sign'
                          );
                          this.setState({showEdit: false});
                        }
                      );
                    }}
                  />
                  <Button
                    id="cancel"
                    name="cancel"
                    text={i18next.t('cancel')}
                    intent="warning"
                    icon="undo"
                    style={{marginLeft: '5px'}}
                    onClick={() => this.setState({showEdit: false})}
                  />
                </FormGroup>
              </div>
            </div>
          </Dialog>

          {this.state.allReports.length === 0 && (
              <div style={{textAlign: 'center', marginTop: '10em'}}>
                <h2><Trans>import report to get started</Trans></h2>
              </div>
          )}

          <div style={{display: 'flex'}}>
            <div
              style={{
                flex: '1 1 45%',
                marginLeft: '10px',
                marginRight: '10px',
                paddingTop: '10px',
                paddingBottom: '10px',
                overflowY: 'auto',
                maxHeight: '80vh',
                scrollbarWidth: 'thin',
              }}
            >
              {this.state.allReports.length > 0 && this.state.allReports.map((report, index) => (
                <div key={new Date().getTime() + index}>
                  <Card
                    key={`${report.id}-${index}-card`}
                    interactive={true}
                    elevation={Elevation.TWO}
                    style={{marginBottom: '6px', backgroundColor: '#E5E8EB', padding: '6px', cursor: 'pointer'}}
                    onClick={() => {
                      this.setState({id: report.id}, () => {
                        this.getReportParams();
                        this.updateiFrame();
                      });
                    }}
                  >
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                      <h3>{report.name}</h3>
                      <Checkbox
                        checked={this.state.id === report.id}
                        onChange={(e) => {
                          e.stopPropagation();
                        }}
                      />
                    </div>

                    <p
                      style={{
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        width: '70%',
                      }}
                    >
                      {report.description}
                    </p>

                    <div style={{display: 'flex', alignContent: 'flex-end', justifyContent: 'flex-end'}}>
                      <Button
                        icon="export"
                        id={report.id}
                        key={`${report.id}`}
                        style={{marginRight: '5px'}}
                        onClick={(e) => {
                          this.showToaster(`${i18n.t('exporting report')} ${report.name}}`, 'primary', 'cloud-download');
                          e.stopPropagation();
                          authenticatedPostFetchWithResult(
                            '/customReport/exportReport',
                            {
                              id: report.id,
                              all: false
                            },
                            (_res, data) => {
                              saveAs(
                                new Blob([data], {type: 'application/zip;charset=utf-8'}),
                                `report_${report.name}.zip`
                              );
                            },
                            () => {
                              this.showToaster(`${i18n.t('error exporting')} ${report.name}`, 'danger', 'warning-sign');
                            },
                            true
                          );
                        }}
                      >
                        {i18next.t('export')}
                      </Button>


                      <Button
                        intent="primary"
                        icon="edit"
                        key={`${report.id}-${index}-btn1`}
                        style={{marginRight: '5px'}}
                        onClick={(e) => {
                          e.stopPropagation();
                          this.setState({
                            showEdit: true,
                            id: report.id,
                            editName: report.name,
                            editDescription: report.description,
                            editCategory: report.category,
                          });
                        }}
                      >
                        {i18next.t('edit')}
                      </Button>
                      <Button
                        icon="trash"
                        intent="danger"
                        key={`${report.id}-${index}-btn2`}
                        onClick={(e) => {
                          e.stopPropagation();
                          authenticatedDeleteFetch(
                            `/customReport/deleteReport/${report.id}`,
                            {},
                            () => {
                              this.getAllReports();
                              this.showToaster(
                                `${i18n.t('report')} ${report.name} ${i18n.t('deleted')}`,
                                'success',
                                'tick'
                              );
                            },
                            () => {
                              this.showToaster(`${i18n.t('error deleting')} ${report.name}`, 'danger', 'warning-sign');
                            }
                          );
                        }}
                      >
                        {i18next.t('delete')}
                      </Button>
                    </div>
                  </Card>
                </div>
              ))}
            </div>

            <div style={{flex: '1 1 50%'}}>
              <Callout intent="info" style={{marginBottom: '5px'}}>
                <h2 style={{marginBottom: '20px'}}>
                  {this.state.id && !this.state.reportError && this.state.allReports.length > 0
                    ? `${i18next.t('report parameters')}: ${this.state.allReports.find((report) => report.id === this.state.id).name}`
                    : ''}
                </h2>

                {this.state.id && !this.state.reportError && (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        width: '100%',
                        padding: '10px',
                        marginBottom: '10px',
                      }}
                    >
                      {this.state.reportParams.map((param, _index) => (
                        <FormGroup
                          label={<Trans>{labels.find((label) => label.index === param.type).label}</Trans>}
                          labelFor={param.type}
                          inline={true}
                          key={param.type}
                          style={{width: '30%', marginRight: '10px'}}
                        >
                          {param.type === 'api_url' && (
                            <InputGroup
                              id={param.type}
                              name={param.type}
                              key={param.type}
                              value={param.value}
                              placeholder={'URL openwilix'}
                              onChange={(e) => {
                                this.setState({api_url: e.target.value});
                              }}
                            />
                          )}
                          {param.type === 'to' || param.type === 'fr' ? (
                            <InputGroup
                              type="date"
                              id={param.type}
                              name={param.type}
                              key={param.type}
                              max={param.type === 'fr' ? this.state.toDate : undefined}
                              min={param.type === 'to' ? this.state.fromDate : undefined}
                              value={param.type === 'to' ? this.state.toDate : this.state.fromDate}
                              onChange={(e) => {
                                if (param.type === 'to') this.setState({toDate: e.target.value });
                                else this.setState({fromDate: e.target.value });
                              }}
                            />
                          ) : (
                            ''
                          )}
                          {param.type === 'handleZero' && (
                            <Checkbox
                              id={param.type}
                              name={param.type}
                              checked={this.state.handleZero}
                              onChange={(e) => {
                                this.setState({handleZero: e.target.checked});
                              }}
                            />
                          )}
                          {param.type === 'lg' && (
                            <Select
                              id={param.type}
                              name={param.type}
                              items={[
                                {index: 'fr', label: 'French'},
                                {index: 'en', label: 'English'},
                              ]}
                              selectedItems={this.state.lg}
                              onChange={(e) => {
                                this.setState({lg: e.target.value});
                              }}
                              itemRenderer={(item, {handleClick}) => {
                                return (
                                  <MenuItem
                                    active={this.state.lg === item.index}
                                    key={item.index}
                                    onClick={handleClick}
                                    text={item.label}
                                  />
                                );
                              }}
                              tagRenderer={(item) => item.label}
                              filterable={false}
                              onItemSelect={(item) => {
                                this.setState({lg: item.index});
                              }}
                            >
                              <Button
                                text={this.state.lg === 'fr' ? 'French' : 'English'}
                                rightIcon="double-caret-vertical"
                              />
                            </Select>
                          )}
                          {(param.type === 'parks' || param.type === 'parklist') && <MultiParkSelect onSelect={(id) => this.setState({parks: id})} />}
                          {param.type === 'park' && <ParkSelect onSelect={(id) => this.setState({parks: id})} />}
                          {(param.type === 'equipment' || param.type === 'equipments') && (
                            <EquipmentSelect onSelect={(id) => this.setState({device: id})} selection={this.state.device} />
                          )}

                          {(param.type === 'g' || param.type === 'granularity') && (
                            <GranularitySelect
                              onSelect={(id) => this.setState({g: id})}
                              selection={this.state.g}
                              displayLabel={false}
                            />
                          )}

                        </FormGroup>
                      ))}
                    </div>
                )}

                {this.state.reportParams.length > 0 && !this.state.reportError && (
                  <div style={{marginBottom: '5px'}}>
                    <Button
                      text={i18next.t('generate')}
                      icon="refresh"
                      intent="success"
                      style={{height: '30px', width: '100px'}}
                      className="bp3-intent-primary"
                      onClick={() => {
                        this.updateiFrame();
                      }}
                    />
                    <Popover
                      placement="bottom-end"
                      content={
                        <Menu className={this.props.className}>
                          <MenuItem
                            text="PDF"
                            icon="document"
                            onClick={() => {
                              this.downloadFile('pdf');
                            }}
                          />
                          <MenuItem
                            text="HTML"
                            icon="code"
                            onClick={() => {
                              this.downloadFile('html');
                            }}
                          />
                          <MenuItem
                            text="CSV"
                            icon="th-filtered"
                            onClick={() => {
                              this.downloadFile('csv');
                            }}
                          />
                          <MenuItem
                            text="EXCEL"
                            icon="th"
                            onClick={() => {
                              this.downloadFile('xlsx');
                            }}
                          />
                          <MenuItem
                            text="WORD"
                            icon="align-justify"
                            onClick={() => {
                              this.downloadFile('docx');
                            }}
                          />
                        </Menu>
                      }
                    >
                      <Button
                        text={i18next.t('download')}
                        icon="download"
                        intent="primary"
                        loading={this.state.loading_download}
                        rightIcon="caret-down"
                        style={{height: '30px', width: '130px', marginLeft: '5px'}}
                        className="bp3-intent-primary"
                      ></Button>
                    </Popover>
                  </div>
                )}
              </Callout>

              {this.state.reportError && this.state.allReports.length > 0 && (
                <div style={{textAlign: 'center'}}>
                  {i18next.t('something went wrong')}
                </div>
              )}

              {this.state.reportParams.length > 0 &&
                !this.state.reportError &&
                (this.state.fromDate && this.state.toDate && this.state.iFrame ? (
                  <iframe
                    srcDoc={this.state.iFrame}
                    title={<Trans>Custom Report</Trans>}
                    width="100%"
                    style={{border: '2px solid black'}}
                    height="700px"
                  ></iframe>
                ) : (
                  this.showLoadingSpinner()
                ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(CustomReport);
